import { forwardRef } from 'react';
import { css, Interpolation } from '@emotion/react';
import { useThemeValues } from '../../../hooks';
import type { BoolInputKey, BoolInputProps } from './types';

export const BoolInput = forwardRef(
  <T extends BoolInputKey>({ trackingId, ...props }: BoolInputProps<T> & { css?: Interpolation }, ref) => {
    const theme = useThemeValues();

    return (
      <input
        css={css`
          width: 100%;
          height: 100%;
          display: block;
          margin: 0;
          padding: 0;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          z-index: ${theme.zIndex.low};
        `}
        data-trackingid={trackingId}
        {...props}
        ref={ref}
      />
    );
  }
);
